<template>
  <div class="col-md-6 col-sm-12 bg-gray-50 border-radius wrapper-content">
    <div class="col-md-12">
      <h4>Revendas</h4>
    </div>
    <div class="col-md-12">
      <div class="border-radius border-gray-solid wrapper-content">
        <div class="row">
          <div class="col-md-12 d-flex d-flex-just-beteween" style="align-items:center">
              <h5>
                Revendas com Mais Projetos
              </h5>
              <div class="wrapper-status">
                <Select2
                  v-model="RankingStatus"
                  :options="Status"
                  :settings="{  }"
                  @select="RankingStatusSelect($event)"
                />
              </div>
              <Select2
                v-model="RankingAno"
                :options="Anos"
                :settings="{  }"
                @select="RankingAnoSelect($event)"
              />
              <Select2
                v-model="RankingMes"
                :options="Meses"
                :settings="{ }"
                @select="RankingMesSelect($event)"
              />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <Loader v-if="!RankingIntegradorasLoading" />
            <bar-chart
              :data="RankingIntegradorasAnual"
              :options="options"
              v-if="RankingIntegradorasLoading && RankingIntegradorasAnual.datasets[0].data.length > 0"
              chart-id="bar-RankingIntegradorasAnual"
              :height="'180'"
            ></bar-chart>
            <div class="text-center" v-else-if="RankingIntegradorasLoading">
              <h4>Sem Dados Para Exibição</h4>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <br />
            <div
              v-for="(Indicador, index) in RankingIntegradorasAnual.labels"
              :key="index"
              class="d-flex d-flex-just-beteween ranking"
            >
              <div class="position" v-html="Indicador"></div>
              <div class="points" v-html="RankingIntegradorasAnual.employers[index]"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BarChart from "../Components/BarChart.vue";
import axios from "axios";
import Select2 from "v-select2-component";

export default {
  props: ["Anos", "Meses"],
  components: {
    BarChart,
    Select2
  },
  data() {
    return {
      RankingStatus: 4,
      Status: [
        { text: "Concluído", id: 0 },
        { text: "Negociando", id: 1 },
        { text: "Aguardando", id: 2 },
        { text: "Efetivado", id: 3 },
        { text: "Todos", id: 4 }
      ],
      RankingIntegradorasLoading: false,
      RankingAno: 2019,
      RankingMes: new Date().getMonth() + 1,
      RankingIntegradorasAnual: {
        employers: null,
        labels: null,
        datasets: [
          {
            backgroundColor: [
              "rgb(175,238,238)",
              "rgb(250,250,210)",
              "rgb(135,206,235)",
              "rgb(152,251,152)",
              "rgb(176,224,230)",
              "rgb(240,230,140)",
              "rgb(238,232,170",
              "rgb(230,230,250)"
            ],
            data: null
          }
        ]
      },
      options: {
        animation: {
          duration: 0
        },
        responsive: true,
        legend: {
          display: false
        },
        plugins: {
          datalabels: {
            color: "#000",
            labels: {
              title: {
                align: "top"
              }
            }
          }
        },
        scales: {
          yAxes: [
            {
              display: false,
              gridLines: {
                display: false
              },
              ticks: {
							  beginAtZero: true
					  	}
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false
              },
            }
          ]
        }
      }
    };
  },
  created() {
    this.fillRanking();
  },
  methods: {
    RankingMesSelect: function(val) {
      this.RankingMes = val.id;
      this.fillRanking();
    },
    RankingAnoSelect: function(val) {
      this.RankingAno = val.id;
      this.fillRanking();
    },
    RankingStatusSelect: function(val) {
      this.RankingStatus = val.id;
      this.fillRanking();
    },

    fillRanking: function() {
      let self = this;
      self.RankingIntegradorasLoading = false;

      axios
        .get(
          this.$apiUrl +
            `Projeto.svc/dashboard/gestaoaldo/GestaoAldo_Ranking?ano=${self.RankingAno}&mes=${self.RankingMes}&status=${self.RankingStatus}`
        )
        .then(function(response) {
          self.RankingIntegradorasAnual.datasets[0].data = response.data.Qtde;
          self.RankingIntegradorasAnual.labels = [
            "1º",
            "2º",
            "3º",
            "4º",
            "5º",
            "6º",
            "7º",
            "8º"
          ];
          self.RankingIntegradorasAnual.employers = response.data.labels;
          self.RankingIntegradorasLoading = true;

          setTimeout(function() {
            // self.$data._chart.update();
            console.log("isso mesmo", self._chart);
            // window.dispatchEvent(new Event('resize'));
          }, 1000);
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>